module.exports = __webpack_public_path__ + "img/home.4dbe68c6.png";